import React from 'react'
import { FlatDomainDataContext, FormBean, IUIViewHeaderDef } from '../../datatypes';
import renderChildUIComponents from './metadata-mapper'
const {MDBContainer} = require('mdbreact');

interface ViewHeaderProps {
    metadata:IUIViewHeaderDef;
    formBean:FormBean;
    ctx:FlatDomainDataContext;
}

export default class ViewHeader extends React.Component<ViewHeaderProps, {}> {
  render() {
    const {metadata} = this.props;
    const {cssClasses} = metadata;
    let className = "viewHeader " + (cssClasses ? cssClasses : '');

    return (
        <MDBContainer role={"header"} fluid className={className}>
            {renderChildUIComponents(this.props)}
        </MDBContainer>
    )
  }
}